import { useContext } from 'react';
import { Auth0Context } from '../components/auth/Auth0Provider';

/**
 * Custom hook to access Auth0 authentication state and methods
 * @returns {Object} Auth0 context with authentication state and methods
 */
export const useAuth = () => {
  const context = useContext(Auth0Context);
  
  if (!context) {
    throw new Error('useAuth must be used within an Auth0Provider');
  }
  
  return context;
};
